<script>
/**
 * ****************************************************************************
 * @description     :   MainLayout
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Best Security
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * import template
 */
import template from './template.html';

/**
 * import component
 */
import HeaderError from '@/components/headerError';
import Loading from '@/components/loading';
import MainHeader from '@/shared/header';
import MainMenu from '@/shared/menu';
import MainFooter from '@/shared/footer';
import ModalMessage from '@/shared/modal-message';

/**
 * Define main layout
 */
export default {
    name: 'MainLayout',
    template: template,
    components: {
        MainHeader,
        HeaderError,
        Loading,
        ModalMessage,
        MainFooter,
        MainMenu
    }
};
</script>
<style lang="scss">
@import 'handsontable/dist/handsontable.full.css';
@import 'flatpickr/dist/flatpickr.css';
@import 'https://fonts.googleapis.com/earlyaccess/sawarabigothic.css';
@import 'https://fonts.googleapis.com/css?family=Roboto:400,300,100,500,700,900';
</style>
